export default __webpack_public_path__ + "static/students1-ac6e1fac8d4a23bfdf7dc094de707a15.jpg";